import { safeCallback } from "../../../../helpers/fn.js";
import { isArray } from "../../../../helpers/is-type.js";
import { BEFORE_MOUNT, BEFORE_UPDATE, LIFECYCLE_NAMES, MOUNTED, UNMOUNTED, UPDATED } from "../../../../constants.js";
//#region ../r-html/dist/render/part/node/component/hooks.js
var currentInstance = null;
function setCurrentInstance(component) {
	currentInstance = component;
}
function getCurrentInstance() {
	return currentInstance;
}
var createLifecycle = (name) => (f) => {
	currentInstance && (currentInstance[name] ?? (currentInstance[name] = [])).push(f);
};
var onBeforeMount = createLifecycle(BEFORE_MOUNT);
var onMounted = createLifecycle(MOUNTED);
var onUnmounted = createLifecycle(UNMOUNTED);
var onBeforeUpdate = createLifecycle(BEFORE_UPDATE);
var onUpdated = createLifecycle(UPDATED);
function lifecycleHooks(instance, name) {
	const hooks = Reflect.get(instance, name, instance);
	isArray(hooks) && hooks.forEach(safeCallback);
}
function clearAllLifecycleHooks(instance) {
	LIFECYCLE_NAMES.forEach((name) => Reflect.set(instance, name, null, instance));
}
//#endregion
export { clearAllLifecycleHooks, getCurrentInstance, lifecycleHooks, onBeforeMount, onBeforeUpdate, onMounted, onUnmounted, onUpdated, setCurrentInstance };
